/* global SWDLocalise */
import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import history from 'instantsearch.js/es/lib/routers/history';
import { connectMenu } from 'instantsearch.js/es/connectors';
import customHits from './widgets/hits-product';
import customMenuSelect from './widgets/menu-select';
import { capFirstLetter } from '../../utils';

const searchResults = document.querySelector('.js-product-search-results');
const searchCats = document.querySelector('.js-product-search-cats');
const productsContent = document.querySelector('.js-products');

const updateContent = (category) => {
    const productsContentJSON = JSON.parse(productsContent.dataset.categories);
    document.querySelector('.js-products-title').textContent = productsContentJSON[category].title;
    document.querySelector('.js-products-content-above').innerHTML = productsContentJSON[category].content_above;
    document.querySelector('.js-products-content-below').innerHTML = productsContentJSON[category].content_below;
    const image = document.querySelector('.js-products-image');
    image.setAttribute('src', productsContentJSON[category].image[0]);
    image.setAttribute('width', productsContentJSON[category].image[1]);
    image.setAttribute('height', productsContentJSON[category].image[2]);
    image.setAttribute('alt', productsContentJSON[category].image_alt);
};

const setup = () => {
    const algoliaClient = algoliasearch(
        SWDLocalise.algoliaAppID,
        SWDLocalise.algoliaAPIKey,
    );

    const searchClient = {
        ...algoliaClient,
    };

    const indexName = `${SWDLocalise.algoliaIndex}product`;

    const search = instantsearch({
        searchClient,
        indexName,
        routing: {
            router: history({
                createURL({ qsModule, routeState, location }) {
                    const urlParts = location.href.match(/^(.*?)\/products/);
                    const baseUrl = `${urlParts ? urlParts[1] : ''}/`;

                    const categoryPath = routeState.category
                        ? `${routeState.category}/`
                        : '';

                    const queryParameters = {};

                    const queryString = qsModule.stringify(queryParameters, {
                        addQueryPrefix: true,
                        arrayFormat: 'repeat',
                    });

                    // handle single URL
                    return `${baseUrl}products/${categoryPath}${queryString}`;
                },

                parseURL({ location }) {
                    const pathnameMatches = location.pathname.match(/products\/(.*?)\/?$/);
                    const category = ((pathnameMatches && pathnameMatches[1]) || '');

                    return { category };
                },
            }),

            stateMapping: {
                stateToRoute(uiState) {
                    const indexUiState = uiState.wp_spb_product || {};

                    return {
                        category: indexUiState.menu && indexUiState.menu['taxonomies.product_cat'],
                    };
                },

                routeToState(routeState) {
                    return {
                        wp_spb_product: {
                            menu: {
                                'taxonomies.product_cat': routeState.category,
                            },
                        },
                    };
                },
            },
        },
        searchFunction(helper) {
            helper.toggleFacetRefinement('visibility', 'visible');

            if (helper.hasRefinements('taxonomies.product_cat')) {
                updateContent(helper.state.hierarchicalFacetsRefinements['taxonomies.product_cat'][0]);
            } else {
                updateContent('all');
            }

            helper.search();
        },
    });

    const virtualMenu = connectMenu(() => null);

    search.addWidgets([
        customMenuSelect({
            container: searchCats,
            attribute: 'taxonomies.product_cat',
            transformItems(items) {
                return items.map((item) => ({
                    ...item,
                    label: item.label.split('-')
                        .map(decodeURIComponent)
                        .map(capFirstLetter)
                        .join(' ')
                        .replace('And', '&'),
                }));
            },
        }),

        virtualMenu({
            attribute: 'visibility',
        }),

        customHits({
            container: searchResults,
        }),
    ]);

    search.start();
};

const init = () => {
    if (!searchCats) return;
    setup();
};

export default init;
